import {Component, HostListener, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RunnerService} from '../../../../services/runner.service';
import {RunningTeam} from '../../../../models/running-team';
import {RunningTeamMember} from '../../../../models/running-team-member';
import firebase from 'firebase/compat/app';
import firestore = firebase.firestore;
import {ToastService} from '../../../../services/toast.service';
import {NgbDate, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Observable} from 'rxjs';
import {animate, style, transition, trigger} from '@angular/animations';
import {GameService} from '../../../../services/game.service';

@Component({
  selector: 'app-running-team',
  templateUrl: './running-team.component.html',
  styles: [],
  animations: [
    trigger(
      'enterAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('200ms', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('200ms', style({ opacity: 0 }))
      ])
    ]
    )
  ]
})
export class RunningTeamComponent implements OnInit {

  constructor(route: ActivatedRoute, public runnerService: RunnerService, public toastService: ToastService,
              private modalService: NgbModal, private router: Router, public game: GameService) {
    runnerService.setRunner(route.snapshot.params.id);
  }

  teamEdited = false;

  protected readonly NgbDate = NgbDate;
  // @HostListener allows us to also guard against browser refresh, close, etc.
  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    return !this.teamEdited;
  }

  saveTeam(team: RunningTeam): void {
    let goodToSave = true;
    team.members.forEach((member, i) => {
      if (member.dob !== null && member.dob !== undefined && !(member.dob instanceof firestore.Timestamp)) {
        this.toastService.show('Invalid date',
          'That date of birth doesn\'t look quite right, it wasn\'t saved. Please try again.', 'danger');
        team.members[i].dob = null;
        goodToSave = false;
      }
    });
    if (goodToSave) {
      this.runnerService.update(team, 0, true);
      this.teamEdited = false;
    }
  }

  addMember(team: RunningTeam): void {
    const member = {} as RunningTeamMember;
    member.wantsFood = true;
    if (team.members == null) {
      team.members = new Array<RunningTeamMember>();
    }
    team.members.push(member);
  }

  // TODO: Rewrite all of this & runners service - it's horrible
  makeTeamLeader(team: RunningTeam, memberIndex: number): void {
    team.members.unshift(team.members.splice(memberIndex, 1)[0]);
  }

  moveToTeam(team: RunningTeam, memberIndex: number, newTeam: RunningTeam): void {
    const member = team.members[memberIndex];
    if (newTeam.members == null) {
      newTeam.members = [];
    }
    newTeam.members.push(member);
    // Remove from current team
    this.runnerService.update(newTeam, 0);
    team.members.splice(memberIndex, 1);
    this.runnerService.update(team, 0, true);
  }

  confirmDeleteMember(content, team: RunningTeam, i: number): void {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then(
      (result) => {
        if (result === 'Delete') {
          team.members.splice(i, 1);
          this.runnerService.update(team, 0, true);
        }
      },
    );
  }

confirmDeleteTeam(content, team): void {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then(
      (result) => {
        if (result === 'Delete') {
          this.teamEdited = false;
          this.runnerService.delete(team.id);
          this.router.navigate(['/']);
        }
      },
    );
  }

  filter(currentTeamId: string, teams?: RunningTeam[]): RunningTeam[] {
    let toReturn: RunningTeam[];
    toReturn = teams?.filter(x => x.id !== currentTeamId);
    return toReturn;
  }

  setDays(date: number, newDays: number): Date {
    const newDate = new Date(date);
    newDate.setDate(newDays);
    return newDate;
  }

  ngOnInit(): void {

  }
}
